<template>
  <div
    class="absolute w-full h-full overflow-hidden top-0 left-0 duration-300 pointer-events-none"
  >
    <div
      class="w-[100vw] h-[100vw]  absolute bottom-0 left-0 pointer-events-none duration-300"
      style="
        background: radial-gradient(
          at 80% 200vw,
          transparent,
          #22202d 50%,
          #22202d 65%,
          transparent
        );
      "
      :class="{ 'opacity-0': !tvsAreVisible,'opacity-[0.9]': tvsAreVisible, }"
    ></div>
    <div
      class="absolute w-full h-full overflow-auto !pointer-events-auto duration-300"
      @click="tvsAreVisible = fales"
      :class="{ '-translate-x-full': !tvsAreVisible }"
    >
      <div class="grid grid-cols-5 px-[10vw] py-8 relative h-full">
        <div class="flex flex-col w-full gap-4 col-span-3">
          <div
            class="overflow-hidden dropShadowLg relative"
            v-for="(tv, i) in tvs"
            :key="i"
            @click.stop="watchTv(tv)"
            :class="{ 'scale-[1.1] my-6': activeTv.id == tv.id }"
          >
            <div
              class="absolute w-full h-full p-1 tpo-0 left-0"
              style="
                background: linear-gradient(
                  to bottom left,
                  #62606d 0%,
                  #2f2c3c 50%,
                  #62606d 100%
                );
              "
            >
              <div
                class="w-full h-full"
                style="
                  background: linear-gradient(
                    to bottom left,
                    #4a475a 0%,
                    #363344 100%
                  );
                "
              ></div>
            </div>
            <div class="relative py-[20%]">
              <div
                class="absolute w-full h-full p-8 top-0 left-0 grid grid-cols-3 gap-4"
              >
                <div class="relative h-full overflow-hidden bg-[#22202D]">
                  <div
                    class="absolute w-full h-full p-4 top-0 left-0"
                    :style="{ backgroundColor: tv.backgroundColor }"
                  >
                    <img
                      :src="tv.logo"
                      class="w-full h-full object-contain"
                      alt=""
                    />
                  </div>
                </div>
                <div class="col-span-2 p-4">
                  <div class="text-4xl font-bold">
                    {{ tv.name }}
                  </div>
                  <div class="py-1"></div>
                  <div class="opacity-60 text-xl">+100 regardent</div>
                </div>
              </div>
            </div>
            <div
              class="absolute w-full h-full top-0 left-0 bg-[#22202D] opacity-20"
              v-if="activeTv.id !== tv.id"
            ></div>
          </div>
        </div>
        <!-- <div class="col-span-2" @click="tvsAreVisible = false"></div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import tvs from '@/utils/raws/tvs.json'

export default defineComponent({
  name: 'TvListSide',
  components: {},
  props: {
    activeTv: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      tvs: tvs,
      tvsAreVisible: false,
      eventsIds: [],
    }
  },
  mounted() {},
  beforeUnmount() {},
  methods: {
    showList() {
      this.tvsAreVisible = true
    },
    watchTv(tv) {
      this.$emit('watchTvRequested', tv)
      this.tvsAreVisible = false
    },
  },
  computed: {},
})
</script>
